import React from 'react';
import { styled, TextV2 } from '@withjoy/joykit';
import { EventConfiguration } from '@apps/workspace/Workspace';
import { useEventPhoto } from '@shared/utils/eventPhoto';

const CountdownContainer = styled.div<{ eventPhoto: string }>`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-image: url(${props => props.eventPhoto});
`;

const CountdownContent = styled.div`
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  padding: 16px;
  align-items: center;
  display: flex; /* Makes the parent a flex container */
  flex-direction: column; /* Arranges items in a column */
  justify-content: flex-end;
`;

const GradientBlur = styled.div`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  z-index: 1;
  mask: linear-gradient(transparent, black);
  backdrop-filter: blur(16px);
`;

const DEFAULT_IMAGE = 'https://dev.withjoy.com/media/386f4bd5-4ee5-4bca-98f6-0663b0504f34/aee8faf0-8aa0-11f0-8f00-056e9c2af0b0-Unsplash_seanwsinclair_C_NJKfnTR5A.jpg';

export const EventCountdown: React.FC<{ eventConfiguration?: EventConfiguration }> = ({ eventConfiguration }) => {
  const { eventPhoto, loading } = useEventPhoto(eventConfiguration?.eventHandle);
  const eventPhotoUrl = eventPhoto?.url ?? DEFAULT_IMAGE;
  const locationInfo = eventConfiguration?.locationInfo;

  if (loading) {
    return <TextV2>Loading...</TextV2>;
  }

  return (
    <CountdownContainer eventPhoto={eventPhotoUrl}>
      <GradientBlur />
      <CountdownContent>
        <TextV2
          width={'100%'}
          typographyVariant={'CalloutHed32Bold'}
          color={'rgba(255,255,255,0.95)'}
          style={{ textShadow: '0px 1px 2px rgba(0,0,0,0.3)' }}
          textAlign={'center'}
        >
          {eventConfiguration?.eventDisplayName ?? 'Untitled Event'}
        </TextV2>
        {locationInfo && (
          <TextV2
            width={'100%'}
            color={'rgba(255,255,255,0.95)'}
            style={{ textShadow: '0px 1px 2px rgba(0,0,0,0.3)' }}
            textAlign={'center'}
          >
            {`${locationInfo.city}, ${locationInfo.state ? locationInfo.state : locationInfo.country ? locationInfo.country : ''}`}
          </TextV2>
        )}
        <TextV2
          width={'100%'}
          color={'rgba(255,255,255,0.95)'}
          style={{ textShadow: '0px 1px 2px rgba(0,0,0,0.3)' }}
          textAlign={'center'}
        >
          {eventConfiguration?.date?.dateString ?? eventConfiguration?.date?.milliseconds ?? 'No Date Set'}
        </TextV2>
      </CountdownContent>
    </CountdownContainer>
  );
};
